import React from "react";
import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/UI";
import { FinanceRecords } from "./finance/FinanceRecords";
import { PayablesTab } from "./finance/PayablesTab";
import { PersonnelTab } from "./finance/PersonnelTab";
import { FeedAnalysisTab } from "./finance/FeedAnalysisTab";

export default function Finance() {
  const [sp] = useSearchParams();
  const tab = sp.get("t") || "records";
  return (
    <div data-testid="finance-page">
      <PageHeader title="Finans" subtitle="Gelir, gider ve ödeme takibi tek yerde." />
      {tab === "records" && <FinanceRecords />}
      {tab === "payables" && <PayablesTab />}
      {tab === "personnel" && <PersonnelTab />}
      {tab === "feed" && <FeedAnalysisTab />}
    </div>
  );
}

// -------- Records (existing) --------
